import { render } from "./HomeBroadcastVideoPlaceholder.vue?vue&type=template&id=8da26e4e"
import script from "./HomeBroadcastVideoPlaceholder.vue?vue&type=script&lang=ts"
export * from "./HomeBroadcastVideoPlaceholder.vue?vue&type=script&lang=ts"

import "./HomeBroadcastVideoPlaceholder.vue?vue&type=style&index=0&id=8da26e4e&lang=postcss"
script.render = render

export default script